"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingSpinnerStyle = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
var LoadingSpinnerStyle;
(function (LoadingSpinnerStyle) {
    LoadingSpinnerStyle[LoadingSpinnerStyle["normal"] = 0] = "normal";
    LoadingSpinnerStyle[LoadingSpinnerStyle["small"] = 1] = "small";
    LoadingSpinnerStyle[LoadingSpinnerStyle["thick"] = 2] = "thick";
})(LoadingSpinnerStyle || (exports.LoadingSpinnerStyle = LoadingSpinnerStyle = {}));
const LoadingSpinner = ({ className, style = LoadingSpinnerStyle.normal, center = false, }) => (react_1.default.createElement("div", { className: (0, classnames_1.default)('znd-loading-spinner', {
        'znd-loading-spinner--thick': style === LoadingSpinnerStyle.thick,
        'znd-loading-spinner--small': style === LoadingSpinnerStyle.small,
    }, {
        'znd-loading-spinner--center': center,
    }, className) },
    react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "407 52 132 124" },
        react_1.default.createElement("path", { className: "znd-loading-spinner__path", d: "M408.5 174.6h69l59.8-60.8-60.1-61h-69v46.6h50.2l12.9 14.4-12.9 14.5h-49.9v46.6" }))));
exports.default = LoadingSpinner;
